// Phần THUẦN của "chồng ngăn" (không React) — kiểm thử được bằng vitest như ./loc.ts.
//
// Chồng ngăn = tối đa 3 ngăn trượt từ phải, chồng lên TRANG đang mở (trang vẫn là route bên dưới, không đổi):
//   Tổng quan  →  [Danh sách: Trễ hạn]  →  [Việc #12]
// Nó sống TRÊN URL để F5 / gửi link / nút Back đều đúng — không có trạng thái thứ hai để lệch.
//
// Mã hoá: ?ngan=<mục>.<mục>.<mục>  (dưới cùng trước, trên cùng sau)
//   · việc        → v<số>                      vd  v12
//   · danh sách   → l<base64url(đường + query)> vd  l + b64("/danh-sach?han=tre")
//   · tài sản     → t<brand>_<slug>[_<mở>]     vd  tgorganic_website_ck_n2  (chỉ [A-Za-z0-9_-]: không có `.`, URLSearchParams
//                   không escape; brand + slug không chứa `_` nên hai dấu `_` đầu luôn tách đúng)
//                   <mở> = tab (tq · ck · vi · nd · ls) + bộ lọc checklist tuỳ chọn: _n<chỉ số nhóm mục> hoặc _k<slug kênh>
// Vì sao base64url cho danh sách: bộ lọc là MỘT query string lồng trong query string. Để thô thì phải escape hai
// lần (`%253D`), còn tách bằng dấu phân cách thì vỡ ngay khi ô tìm kiếm có `.` `,` `&` `=` hay chữ có dấu.
// base64url chỉ gồm [A-Za-z0-9_-], không bao giờ chứa `.` → tách mục an toàn, một tham số, không escape gì thêm.
// Đường của danh sách bị giới hạn trong DUONG_DS (không ai nhét được đường lạ vào nút "Mở toàn trang").
//
// Tương thích: chồng chỉ gồm ĐÚNG MỘT việc vẫn ghi là ?viec=12 như trước (link chia sẻ quen thuộc, xuất Excel,
// markdown `?viec=12`, mọi e2e cũ) — ?ngan= chỉ xuất hiện khi có danh sách hoặc từ 2 ngăn trở lên. Đọc: ?ngan= thắng.
import { KHOA_URL, KHONG_BRAND, tenLocCho, tenLocTao, tenLocXong } from './loc';
import { LOC_HAN } from './viec';
import { nhanPha, tenKenh } from './pha-kenh';

export const TOI_DA_NGAN = 3;
export const DUONG_DS = ['/danh-sach', '/can-duyet'] as const;
export type DuongDs = (typeof DUONG_DS)[number];

export type MucNgan = { loai: 'viec'; so: number } | { loai: 'ds'; duong: DuongDs; q: string } | { loai: 'ts'; brand: string; slug: string; mo?: string };

export const mucViec = (so: number): MucNgan => ({ loai: 'viec', so });
export const mucTs = (brand: string, slug: string, mo?: string): MucNgan => (mo ? { loai: 'ts', brand, slug, mo } : { loai: 'ts', brand, slug });

// Ngăn tài sản: tab đang mở + bộ lọc checklist. Chuỗi lạ → tab Tổng quan, không lọc.
export const TAB_TS = ['tq', 'ck', 'vi', 'nd', 'ls'] as const;
export type TabTs = (typeof TAB_TS)[number];
export interface MoTs { tab: TabTs; nhom?: number; kenh?: string }
export function docMoTs(mo: string | undefined): MoTs {
  const m = (mo || '').match(/^(tq|ck|vi|nd|ls)(?:_(?:n(\d{1,2})|k([a-z0-9]+(?:-[a-z0-9]+)*)))?$/);
  if (!m) return { tab: 'tq' };
  const kq: MoTs = { tab: m[1] as TabTs };
  if (m[2] !== undefined) kq.nhom = Number(m[2]);
  if (m[3] !== undefined && m[3].length <= 40) kq.kenh = m[3];
  return kq;
}
export function ghiMoTs(m: MoTs): string | undefined {
  const loc = m.nhom !== undefined ? `_n${m.nhom}` : m.kenh ? `_k${m.kenh}` : '';
  return m.tab === 'tq' && !loc ? undefined : m.tab + loc;
}
// q = query string của bộ lọc (không có '?'); chuẩn hoá qua URLSearchParams để hai cách viết cùng bộ lọc là một mục.
export const mucDs = (duong: DuongDs, q = ''): MucNgan => ({ loai: 'ds', duong, q: new URLSearchParams(q).toString() });

function b64url(s: string) {
  let nhi_phan = '';
  for (const b of new TextEncoder().encode(s)) nhi_phan += String.fromCharCode(b);
  return btoa(nhi_phan).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function tuB64url(s: string): string | null {
  if (!/^[A-Za-z0-9_-]*$/.test(s)) return null;
  try {
    const nhi_phan = atob(s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4));
    return new TextDecoder('utf-8', { fatal: true, ignoreBOM: false }).decode(Uint8Array.from(nhi_phan, (c) => c.charCodeAt(0)));
  } catch {
    return null;
  }
}

export function maHoaMuc(m: MucNgan): string {
  if (m.loai === 'ts') return `t${m.brand}_${m.slug}` + (m.mo ? '_' + m.mo : '');
  return m.loai === 'viec' ? 'v' + m.so : 'l' + b64url(m.duong + (m.q ? '?' + m.q : ''));
}

export function giaiMaMuc(s: string): MucNgan | null {
  if (/^v[1-9]\d{0,8}$/.test(s)) return mucViec(Number(s.slice(1)));
  const ts = s.match(/^t([A-Za-z0-9][A-Za-z0-9-]{0,47})_([a-z0-9]+(?:-[a-z0-9]+)*)(?:_([a-z0-9_-]{1,48}))?$/);
  if (ts && ts[2].length <= 40) return mucTs(ts[1], ts[2], ts[3] ? ghiMoTs(docMoTs(ts[3])) : undefined);
  if (s[0] !== 'l') return null;
  const url = tuB64url(s.slice(1));
  if (url === null) return null;
  const i = url.indexOf('?');
  const duong = i < 0 ? url : url.slice(0, i);
  if (!(DUONG_DS as readonly string[]).includes(duong)) return null;
  return mucDs(duong as DuongDs, i < 0 ? '' : url.slice(i + 1));
}

export const giongNhau = (a: MucNgan, b: MucNgan) => maHoaMuc(a) === maHoaMuc(b);

// search: query string hiện tại (có hoặc không có '?'). Mục hỏng bị bỏ qua, quá 3 thì giữ 3 mục TRÊN cùng.
export function docNgan(search: string): MucNgan[] {
  const p = new URLSearchParams(search);
  const tho = p.get('ngan');
  if (tho !== null) return tho.split('.').map(giaiMaMuc).filter((m): m is MucNgan => !!m).slice(-TOI_DA_NGAN);
  const so = Number(p.get('viec'));
  return Number.isInteger(so) && so > 0 ? [mucViec(so)] : [];
}

// Query string mới (không '?') = search hiện tại với chồng thay bằng `ds`. Các tham số khác của trang giữ nguyên.
export function ghiNgan(search: string, ds: MucNgan[]): string {
  const p = new URLSearchParams(search);
  const chong = ds.slice(-TOI_DA_NGAN);
  p.delete('viec');
  p.delete('ngan');
  if (chong.length === 1 && chong[0].loai === 'viec') p.set('viec', String(chong[0].so));
  else if (chong.length) p.set('ngan', chong.map(maHoaMuc).join('.'));
  return p.toString();
}

// Mở thêm một ngăn: trùng ngăn trên cùng → giữ nguyên (cùng mảng, để nơi gọi biết không cần điều hướng);
// chồng đã đủ 3 → THAY ngăn trên cùng (hai ngăn dưới vẫn là đường về).
export function dayNgan(ds: MucNgan[], m: MucNgan): MucNgan[] {
  const tren = ds[ds.length - 1];
  if (tren && giongNhau(tren, m)) return ds;
  return ds.length >= TOI_DA_NGAN ? [...ds.slice(0, TOI_DA_NGAN - 1), m] : [...ds, m];
}

// Đóng ngăn trên cùng.
export const dongTren = (ds: MucNgan[]) => ds.slice(0, -1);
// Về ngăn thứ i (0 = dưới cùng; -1 = đóng hết, về trang).
export const rutVe = (ds: MucNgan[], i: number) => ds.slice(0, Math.max(0, i + 1));
// Thay mục thứ i (đổi bộ lọc trong ngăn danh sách) — các ngăn phía trên nó bị bỏ vì chúng mở ra TỪ danh sách cũ.
export const thayMuc = (ds: MucNgan[], i: number, m: MucNgan) => (i < 0 || i >= ds.length ? ds : [...ds.slice(0, i), m]);

// "Mở toàn trang" của một ngăn danh sách.
export const urlToanTrang = (m: Extract<MucNgan, { loai: 'ds' }>) => m.duong + (m.q ? '?' + m.q : '');

// So sánh URL không phụ thuộc cách escape (`brand:x` và `brand%3Ax` là một).
export function chuanHoaUrl(duong: string, search: string) {
  const q = new URLSearchParams(search).toString();
  return duong + (q ? '?' + q : '');
}

// Tên ngắn của ngăn danh sách cho vụn bánh mì / tiêu đề ngăn: "Danh sách · Trễ hạn · brand X".
export function tenMucDs(m: Extract<MucNgan, { loai: 'ds' }>, tenNguoi: (id: number) => string = (id) => '#' + id): string {
  const p = new URLSearchParams(m.q);
  const phan: string[] = [m.duong === '/can-duyet' ? 'Cần duyệt' : 'Danh sách'];
  const nguoi = p.get(KHOA_URL.nguoi);
  if (nguoi) phan.push(nguoi === 'chua-giao' ? 'Chưa giao' : tenNguoi(Number(nguoi)));
  const han = LOC_HAN.find((h) => h.ma === p.get(KHOA_URL.han));
  if (han) phan.push(han.ten);
  const xong = p.get(KHOA_URL.xong);
  if (xong) phan.push(tenLocXong(xong));
  const tao = p.get(KHOA_URL.tao);
  if (tao) phan.push(tenLocTao(tao));
  const cho = Number(p.get(KHOA_URL.cho));
  if (cho) phan.push(tenLocCho(cho));
  const brand = p.get(KHOA_URL.brand);
  if (brand) phan.push(brand === KHONG_BRAND ? 'Không brand' : brand.replace(/^brand:/, ''));
  const pha = p.get(KHOA_URL.pha);
  if (pha) phan.push(nhanPha(pha));
  const kenh = p.get(KHOA_URL.kenh);
  if (kenh) phan.push(tenKenh(kenh));
  for (const k of ['tag', 'uu_tien', 'linh_vuc', 'doi_tac'] as const) {
    const v = p.get(KHOA_URL[k]);
    if (v) phan.push(v.replace(/^[a-z-]+:/, ''));
  }
  const tim = p.get(KHOA_URL.tim);
  if (tim) phan.push(`"${tim}"`);
  return phan.join(' · ');
}
